/**
 * @generated SignedSource<<deb8397ae34010de9febd3d34b875fc9>>
 * @relayHash c81edbedabd3a07bb4c131163defdd60
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 662dba7b6b58fc2f7fb7095611d6ca086899027bdfe189caf512accfcfab4815

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentStateInput = {
  color?: string | null;
  id?: AGG$Long | null;
  name?: string | null;
  spaceKey?: string | null;
};
export type ContentStateGroupSetContentStateMutation$variables = {
  contentId: string;
  contentStateInput: ContentStateInput;
};
export type ContentStateGroupSetContentStateMutation$data = {
  readonly setContentState: {
    readonly color: string;
    readonly id: string | null;
    readonly name: string;
    readonly restrictionLevel: ContentStateRestrictionLevel;
  } | null;
};
export type ContentStateGroupSetContentStateMutation = {
  response: ContentStateGroupSetContentStateMutation$data;
  variables: ContentStateGroupSetContentStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStateInput"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentState",
        "variableName": "contentStateInput"
      }
    ],
    "concreteType": "ContentState",
    "kind": "LinkedField",
    "name": "setContentState",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "restrictionLevel"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentStateGroupSetContentStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentStateGroupSetContentStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c81edbedabd3a07bb4c131163defdd60",
    "id": "662dba7b6b58fc2f7fb7095611d6ca086899027bdfe189caf512accfcfab4815",
    "metadata": {},
    "name": "ContentStateGroupSetContentStateMutation",
    "operationKind": "mutation",
    "text": "mutation ContentStateGroupSetContentStateMutation($contentId:ID!,$contentStateInput:ContentStateInput!){setContentState(contentId:$contentId,contentState:$contentStateInput){name,color,id,restrictionLevel}}"
  }
};
})();

(node as any).hash = "9bf862412febf809155ba549e5c2b02e";

export default node;
